const Messages = {
  FreeQuoteFilter: 'FreeQuote Filter',
  FreeQuoteParam: 'FreeQuote Param',
  No_Products_Available: 'No Products Available',
  HarmonySecretKey: 'Please#dont@share&me',
  WebsiteAppState: 'WebsiteAppState',
  BannerType: 'main_BannerType',
  ReloadPage: 'reloadpage',
  notFoundPath: '/nofounds',
  // S3_BUCKET_URL: process.env.REACT_APP_S3_BUCKET_URL,
  RecentUrlFromNavigation: 'RecentUrlFromNavigation',
  PageVisitStatus: 'PageVisitStatus',
  VersionUpdate: '_uvid',
  VirtualRingBuilder: 'VirtualRingBuilder',
  LastRecentUrl: 'recent_url',
  SettingScroll: 'SettingScroll',
  LastGalleryUrlWedding: 'LastGalleryUrlWedding',
  Secretkey: 'my-secret-key@123',
  grecaptcha: '_grecaptcha',
  pageId: 'pageId',
  Exclude_VAT: 'Ex VAT',
  // for Recent Product
  last_recent_product: 'last_recent_product',
  WishList: 'WishList',
  CartProducts: 'cart_products',
  localStorageDatabase: 'firebaselocalstorage',
  uuid: '_uuid',
  Country: 'country',
  PriceColumn: 'priceColumn',
  Currency: 'currency',
  success: 'success',
  warning: 'warning',
  error: 'Error',

  // For customers
  Thankyou: 'Thank You',
  RegistrationSuccess: 'Your account is created successfully.',
  ResetPasswordLinkSent: 'Password reset link has been sent to your registered email.',
  InvalidEmailAddress: 'Email address is not registered with us.',
  PasswordChanged: 'Password changed successfully',
  ResetPassword: 'Reset Password',
  EmptyWishlist: 'Your wishlist is empty.',
  // WrongPromoCode : 'Incorrect Promo Code Please Try another Promo Code';
  WrongPromoCode: 'Invalid promo code.',
  CouponCodeLoginRequired: 'Please login to apply coupon code.',
  AccountUpdated: 'Account updated successfully',
  ConfirmDelete: 'Delete Record?',
  MessageDelete: 'Data will not be retrieved once deleted.',
  AddressAdded: 'Address added successfully',
  AddressUpdated: 'Address updated successfully',
  NewsletterThankyou: 'Thank You',
  NewsletterAlreadyTitle: 'Already with us',
  NewsletterAlready: 'You are already subscribed to our promotions and offers.',
  NewsletterSubmitted: 'You will get notify about our exclusive offers.',
  Newsletter_Thankyou: 'Thank You',
  BookingConfirmed: 'Booking Confirmed',
  BookingConfirmedMessage: 'Your appointment has been successfully booked. We look forward to seeing you!',

  UserAccountInactive: 'Your email is inactive. Contact to Administrator.',
  EmailAlreadyExists: 'Email already exists.',
  InStock: 'In Stock and Ships Today!',
  NotInStock: 'This Item is Made to Order',
  UpdateCart: 'Update To Cart',
  AddCart: 'Add To Cart',
  CartEmpty: 'Your shopping cart is empty.',
  LastAddedCart: 'lastAddedCart',
  LastAddedWishlist: 'lastAddedWishlist',
  LastActionTime: 'lastActionTime',
  ReviewSubmitted: 'Review is submitted.',
  NoProductFound: 'No ProductFound',
  Tokenchar: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
  is_subscribed: 'is_subscribed',
  privacy_policy: 'privacy_policy',
  send_me_copy: 'send_me_copy',
  subscribe: 'subscribe',

  // Default URLs
  diamond_not_compatible: 'Diamond Not Compatible',
  EarthDiamond: '/loose-diamonds/natural-diamonds',
  LabGrownDiamond: '/loose-diamonds/lab-grown-diamonds',
  EngagementRing: '/engagement-rings/all-settings',
  FineJewelryEarring: '/fine-jewelry/design-your-own-studs',
  WomenBand: '/women-band/all-settings',
  FineJewelryEarringmatchingPair: '/matching-pairs/natural-diamonds/round-cut',
  FineJewelryEarringLabDiamondmatchingPair: '/matching-pairs/lab-grown-diamonds/round-cut',
  Gemstones: '/gemstones/all-gemstones',
  SettingType: 'settingType', // 0:setting, 1:diamond, 2:earring, 3:ring studio,4:gemstone
  IsGemstone: 'isGemstone',
  Build_Your_Own_Stoage_Key: 'last_customized_product',
  Notmatchedwithpassword: 'Not matched with password.',
  CompareProducts: 'compare_products',
  RingBuilderShapeNotMatch:
    'The ring and diamond you have selected do not match. Change your jewel or stone.',
  GemstoneRingBuilderShapeNotMatch:
    'The ring and gemstone you have selected do not match. Change your jewel or stone.',
  CompleteJewel: 'Complete Jewel',
  BuildYourOwnStoageKeyFrom: 'last_customized_product_from',
  BuildYourOwnStoageKeyId: 'last_customized_product_id',
  CompleteJewelSlug: '/complete-jewel',
  TermsCondition: 'Terms and Privacy Policy',
  DuplicateDiamondsInCart: 'Duplicate Diamond in your Shopping Cart.',
  DuplicateGemstonesInCart: 'Duplicate Gemstone in your Shopping Cart.',
  DuplicateDiamondGemstoneInCart: 'Duplicate Diamond/Gemstone in your Shopping Cart.',
  SoldDiamondsInCart: 'Sold Diamond in your Shopping Cart.',
  SoldGemstoneInCart: 'Sold Gemstone in your Shopping Cart.',
  SoldDiamondGemstoneInCart: 'Sold Diamond/Gemstone in your Shopping Cart.',
  PaymentIntent: 'payment_intent',
  StripePublicKey: 'stripe_public_key',
  PaypalClientId: 'paypal_client_id',
  AuthorizeNetAPILoginId: 'authorize_net_login_id',
  AuthorizeNetClientKey: 'authorize_net_client_key',
  OrderTotal: 'Order total',
  PromoCode: 'promo_code',
  CustomerCareNumber: 'customer_care_phone',
  CustomerSupportEmail: 'support_email',
  StoreAddress: 'store_address',
  IsShowAnnouncementBar: 'is_show_announcement_bar',
  AnnouncementText: 'announcement_text',
  FacebookUrl: 'facebook_url',
  InstagramUrl: 'instagram_url',
  YoutubeUrl: 'youtube_url',
  PinterestUrl: 'pinterest_url',
  XtwitterUrl: 'xtwitter_url',
  TiktokUrl: 'tiktok_url',
  BlueskyUrl: 'bluesky_url',
  SnapchatUrl: 'snapchat_url',
  GlobalSettingValue: 'hj_value',
  HarmonySettingKey: 'hj_key',
  GiftCardProductUrl: 'gift_card_product_url',
  FreeShippingOrderAmount: 'free_shipping_order_amount',
  SoldOut: 'Sold Out',
  FilterInputTypes: {
    Radio: 'radio',
    RangeSlider: 'range_slider',
    Slider: 'slider'
  },
  Filters: {
    Shape: 'shape',
    Style: 'style',
    Carat: 'carat',
    Price: 'price',
    Cut: 'cut',
    GemstoneShape: 'gemstone_shape',
    GemstoneCut: 'gemstone_cut'
  },
  IsFromDirectURL: 'IsFromDirectURL',
  GoogleClientId: 'google_client_id',
  FacebookAppId: 'facebook_app_id',
  InternationalShippingNote:
    'International shipping rates and fees vary depending on the destination, and any applicable duties, taxes, or customs charges are the responsibility of the customer. We strive to provide the best shipping options, but please note that these costs are determined by local regulations and may differ by region.',
  NewsletterAlready_title: 'Already with us',
  DeliveryNotes:
    'Estimated delivery within 4 - 8 weeks to make the ring from scratch in your desired finger size.',
  cookiesPopup: 'cookiespopup'
}
export default Messages
